import { render, staticRenderFns } from "./FieldNumeric.vue?vue&type=template&id=46041e89&lang=pug&"
import script from "./FieldNumeric.vue?vue&type=script&lang=ts&"
export * from "./FieldNumeric.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports